(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-bf-ct"] && !Shopify.designMode) return;
  try {
    class FramarDayCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = this.dataset.endDate;
      if (!this.endDate) return;
      this.end = new Date(this.endDate).getTime();
      if (isNaN(this.end)) return;
      this.fields = {};
      var self = this;
      this.querySelectorAll('[data-unit]').forEach(function (el) {
        self.fields[el.getAttribute('data-unit')] = el;
      });
      this.update();
      this.interval = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    update() {
      var distance = this.end - Date.now();
      if (distance <= 0) {
        clearInterval(this.interval);
        distance = 0;
      }
      var v = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance % 86400000) / 3600000),
        minutes: Math.floor((distance % 3600000) / 60000),
        seconds: Math.floor((distance % 60000) / 1000)
      };
      for (var k in v) {
        if (this.fields[k]) this.fields[k].textContent = String(v[k]).padStart(2, '0');
      }
    }
  }

  if (!customElements.get('framar-day-countdown')) {
    customElements.define('framar-day-countdown', FramarDayCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-bf-filter"] && !Shopify.designMode) return;
  try {
    class StickyFilterBf extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-anchor-link]'));
      if (!this.links.length) return;
      var self = this;
      this.sections = this.links
        .map(function (l) { return document.getElementById((l.getAttribute('href') || '').replace('#', '')); })
        .filter(Boolean);

      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.setActiveLink(entry.target.id);
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      this.sections.forEach(function (s) { self.observer.observe(s); });

      this.links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var id = (link.getAttribute('href') || '').replace('#', '');
          var target = document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - (self.offsetHeight || 0) - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
          self.setActiveLink(id);
        });
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    setActiveLink(id) {
      this.links.forEach(function (link) {
        link.classList.toggle('active', link.getAttribute('href') === '#' + id);
      });
    }
  }

  if (!customElements.get('sticky-filter-bf')) {
    customElements.define('sticky-filter-bf', StickyFilterBf);
  }

  function fmrSyncHeaderHeight() {
    var header = document.querySelector('#shopify-section-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  fmrSyncHeaderHeight();
  window.addEventListener('load', fmrSyncHeaderHeight);
  window.addEventListener('resize', function () {
    clearTimeout(window.__fmrHeaderTimer);
    window.__fmrHeaderTimer = setTimeout(fmrSyncHeaderHeight, 150);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-bf-grid"] && !Shopify.designMode) return;
  try {
    class ProductListsBf extends HTMLElement {
    connectedCallback() {
      this.scrollAmount = 250;
      var self = this;
      this.querySelectorAll('[class*="custom-scroll-left-"], [class*="custom-scroll-right-"]')
        .forEach(function (button) {
          var back = /custom-scroll-left-/.test(button.className);
          button.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = button.getAttribute('data-list-index');
            var container = self.querySelector('[data-scroll-container="' + idx + '"]');
            if (!container) return;
            container.scrollBy({
              left: back ? -self.scrollAmount : self.scrollAmount,
              behavior: 'smooth'
            });
          });
        });
    }
  }

  if (!customElements.get('product-lists-bf')) {
    customElements.define('product-lists-bf', ProductListsBf);
  }
  } catch(e) { console.error(e); }
})();

})();
